angular.module('umFormViewer', [])
    .config(function ($stateProvider) {})
    .run(function () {});

require('./debug/debuggerComponent');
require('./component/directive/uiHideEmptySection');

